import template from './system_notifications_add.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';
import ClassicEditor from '../../lib/ckeditor/build/ckeditor.js';
import ClassicEditorConfig from '../../lib/ClassicEditorConfig.js';

class SystemNotificationsAddViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.message = ko.observable('');
		this.notifications_category = ko.observableArray();
		this.notifications = ko.observableArray();
		this.recipients = ko.observableArray([]);
		this.employee_group = ko.observableArray();
		this.departments = ko.observableArray();
		this.chkSendEmail = ko.observable(false);
		this.editing = ko.observable(false);
		this.title = ko.observable();
		this.creating = ko.observable(false);

		//search employees/recipients
		this.search_string = ko.observable('');
		this.all_recipients = ko.observableArray([]);
		this.selected_recipients = ko.observableArray();

		this.show_save = ko.computed(() => {
			if (this.notifications().length === 1)
				return (this.notifications()[0].notifications_status !== 'Sent');

			return true;
		});

		this.search_string.subscribe((value) => {
			this.dialog.update_search_data();
		});
	}

	close()
	{
		this.dialog.close();
	}

	select_recipient(data)
	{
		this.selected_recipients.push(data);
		this.all_recipients.removeAll();
		this.search_string('');
		this.recipients.push(data.employee_id);
	}

	remove_recipient(data)
	{
		this.selected_recipients.remove(data);
		this.recipients.remove(data.employee_id);
		this.search_string('');
	}

	async save_notification() 
	{
		if (document.getElementById('txtSubject').value == '' || document.getElementById('txtSubject').value ==  null)
		{
			Grape.alerts.alert({type: 'error', title: tr('Invalid'), message: tr('Subject cannot be empty!')});
			return;
		}
		if (!this.recipients())
		{
			Grape.alerts.alert({type: 'error', title: tr('Invalid'), message: tr('No recipients selected')});
			return;
		}
		let data = {
			notifications_id: document.getElementById('txtID').value,
			message: this.dialog.editor.getData(),
			subject: document.getElementById('txtSubject').value,
			sub_title: document.getElementById('txtSub_Title').value,
			notifications_category: document.getElementById('ddlCategory').value,
			notifications_status: 'New',
			user_created_id: Utils.current_employee_id(),
			employees: this.recipients(),
			active: true,
			send_as_email: document.getElementById('chkSendEmail').checked
		};

		if (data.notifications_id == '')
			data.notifications_id = null;
		
		let res = await Grape.fetches.postJSON('/notifications/save_notification', data);
		if (res.status == 'OK')
		{
			if (data.send_as_email == true)
			{
				let response = await Grape.alerts.confirm({type: 'info', title: tr('Confirm'), message: tr('Successfully saved notification, do you want to send it now?', 'Successfully saved notification, do you want to send it now?')});
				if (response)
				{
					data.notifications_id = res.notifications_id;
					let result = await Grape.fetches.postJSON('/notifications/send_notification', data);
					
					if (result.status == 'OK')
					{
						await Grape.alerts.alert({type: 'success', message: tr('Successfully sent notification.'), title: tr('Success', 'Success')});
						this.dialog.close();
					}
					else if (result.status == 'ERROR')
					{
						Grape.alerts.apiError(result);
						this.dialog.close();
					}
					else
						Grape.alerts.alert({type: 'error', message: tr('Could not send email...', 'Could not send email...'), title: tr('Error', 'Error')});
				}
				else
					this.dialog.close();
			}
			else
			{
				await Grape.alerts.alert({type: 'success',message: tr('Successfully saved notification.', 'Successfully saved notification.'),title: tr('Success', 'Success')});
				this.dialog.close();
			}
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else if (res.error)
			Grape.alerts.alert({type: 'error', message: res.error, title: tr('Error', 'Error')});
		else
		{
			await Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
			this.dialog.close();
		}
	}

	async add_group(v)
	{
		// Populate recipients text box with existing data
		for (let i = 0; i < v.recipients.length; i++)
		{
			let already_selected = this.selected_recipients().some(recipient => recipient.employee_id === v.recipients[i].employee_id);

			if (!already_selected)
			{
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'employee',
					limit: 1000000, 
					filter: [{ value: v.recipients[i].employee_id, op: '=', field: 'employee_id' }] 
				});

				if (res.records != null)
				{
					let name = res.records[0].firstname + ' ' + res.records[0].surname + ' (' + res.records[0].id_number + ')';
					let id = parseInt(res.records[0].employee_id);
				
					this.recipients.push(id);
					this.selected_recipients.push({name: name, employee_id: id});
				}
			}
		}
	};

	async add_department_group(v)
	{
		// Populate recipients text box with exitsting data
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'v_active_employees_department',
			schema: 'savanna', limit: 1000000,
			filter: [{ value: v.department_id, op: '=', field: 'department_id' }]
		}); 

		if (res.records != null)
		{
			for (let i = 0; i < res.records.length; i++)
			{
				let employee_id = parseInt(res.records[i].employee_id);
	
				// Check if the employee is already in the selected_recipients
				let already_selected = this.selected_recipients().some(recipient => recipient.employee_id === employee_id);
	
				// If not already selected, fetch the employee details and add them
				if (!already_selected)
				{
					let result = await Grape.fetches.getJSON('/api/record', {
						table: 'employee',
						limit: 1000000, 
						filter: [{ value: employee_id, op: '=', field: 'employee_id' }]
					});
	
					if (result.records != null && result.records.length > 0)
					{
						let name = result.records[0].firstname + ' ' + result.records[0].surname + ' (' + result.records[0].id_number + ')';
						let id = parseInt(result.records[0].employee_id);
					
						this.recipients.push(id);
						this.selected_recipients.push({name: name, employee_id: id});
					}
				}
			}
		}
	}
}

class SystemNotificationsAddPage
{
	constructor(bindings)
	{
		this.viewModel = new SystemNotificationsAddViewModel(this);
		this.bindings = bindings;
		this.editor = null;
	}

	async init()
	{
		if (this.bindings)
			this.viewModel.message(this.bindings.message || '  ');

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_employee_group',
				schema: 'savanna',
				limit: 1000000
			}); 

			this.viewModel.employee_group(res.records);

			// Populate department fields
			res = await Grape.fetches.getJSON('/api/record', { 
				table: 'v_department_company', 
				schema: 'savanna', 
				limit: 1000, 
				sortfield: 'department', 
				sortorder: 'asc' 
			});

			for (let i = 0; i < res.records.length; i++)
				res.records[i].name = res.records[i].department + ' (' + res.records[i].company + ')';

			this.viewModel.departments(res.records);

			res = await Grape.fetches.getJSON('/api/record', { table: 'notifications_category', limit: 1000000 });
			
			if (res)
				this.viewModel.notifications_category(res.records);

			if (typeof this.bindings.notifications_id === 'undefined')
			{
				this.viewModel.editing(false);
				this.viewModel.title('Create Notification');
				this.viewModel.creating(true);
				this.viewModel.notifications([{
					'notifications_id': 0,
					'message': '',
					'subject': '',
					'sub_title': '',
					'notifications_category': '',
					'notifications_status': '',
					'user_created_id': '',
					'active': true, 'date_created': '',
					'send_as_email': false 
				}]);
			}
			else
			{
				this.viewModel.editing(true);
				res = await Grape.fetches.getJSON('/api/record', { 
					table: 'v_notifications',
					schema: 'savanna',
					limit: 1000000, 
					filter: [{
						value: this.bindings.notifications_id,
						operand: '=',
						field: 'notifications_id'
					}] 
				});

				this.viewModel.notifications(res.records);

				//determine dialog title
				if (res.records[0].notifications_status == 'Sent')
					this.viewModel.title('View Notification');
				else
					this.viewModel.title('Edit Notification');

				// Populate recipients text box with exitsting data
				if (res.records[0].recipients !== null)
				{
					for (let i = 0; i < res.records[0].recipients.length; i++)
					{
						let emp = await Grape.fetches.getJSON('/api/record', { 
							table: 'employee',
							limit: 1000000, 
							filter: [{
								value: res.records[0].recipients[i].employee_id,
								operand: '=',
								field: 'employee_id'
							}]
						});

						if (emp.records != null)
						{
							let names = emp.records[0].firstname + ' ' + emp.records[0].surname + ' (' + emp.records[0].id_number + ')';
							let ids = emp.records[0].employee_id
							this.viewModel.recipients.push(emp.records[0].employee_id);
							this.viewModel.selected_recipients.push({name: names, employee_id: ids});
						}
					}
				}
			}
			this.enable_ckeditor();

		} catch(err) {}
	}

	async update_search_data()
	{
		let options = {
			table: 'employee',
			limit: 1000000,
			filter_join: 'OR',
			filter: []
		}

		//Search and get data for adding manager
		if (this.viewModel.search_string() && this.viewModel.search_string() != '')
		{
			options.filter.push({
				field: 'firstname',
				operand: 'ILIKE',
				value: `%${this.viewModel.search_string()}%`
			})

			options.filter.push({
				field: 'surname',
				operand: 'ILIKE',
				value: `%${this.viewModel.search_string()}%`
			})

			let result = await Grape.fetches.getJSON('/api/record', options);
			if (result.status != 'ERROR')
			{

				if (result.records != null)
				{
					let selectedIds = this.viewModel.selected_recipients().map(recipient => recipient.employee_id);
					let filteredRecords = result.records.filter(record => !selectedIds.includes(record.employee_id));
	
					let employees = filteredRecords.map((emp) => ({
						name: emp.firstname + ' ' + emp.surname + ' (' + emp.id_number + ')',
						employee_id: emp.employee_id
					}));
					this.viewModel.all_recipients(employees);
				}
			}
		}
		else
			this.viewModel.all_recipients([]);
	}

	enable_ckeditor()
	{
		// load the ckeditor
		if (!this.editor)
			ClassicEditor.create(document.getElementById('message_editor'),
				Object.assign({}, ClassicEditorConfig, {
					height: '20em',
					toolbar: {
						items: [
							'|', 'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript',
							'|', 'removeFormat', '|', 'Link' ,'|',  'undo', 'redo'
						]
					},
				})
			).then((editor) => {
				this.editor = editor;
				this.editor.setData(this.viewModel.message());
			}).catch((err) => {
				console.error(err);
			});
	}
};

export default {
	name: 'SystemNotificationsAdd',
	dialog_class: SystemNotificationsAddPage,
	template: template,
	template_filename: 'translation/dialogs/system_notifications_add',
	provider: 'ps'
};
